import React, { useEffect } from 'react';
import { Outlet } from "react-router-dom";

import AOS from 'aos';
import 'aos/dist/aos.css'; // AOS animation styles
// Import Components
import NavBar from './NavBar';
import Footer from './Footer';

const Layout = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS
  }, []);

  return (
        <>
            <NavBar />
            <Outlet />
            <Footer />
        </>
  );
};

export default Layout;
